module.exports = __webpack_public_path__ + "Icono_Medico-Bco_512px.png";